import queryString from 'query-string';

export const getURLQuery = (search = null, key) => {
    const obj = queryString.parse(search)
    if (key) return obj[key]
    return obj
}


